import { useEffect, useRef, useState } from "react"

/**
 * 公告轮播 Hook
 * @description 多条公告时，每 8 秒自动切换到下一条
 * @param totalCount 公告总数
 * @param hasMultiple 是否有多条公告
 * @param isVisible 是否可见
 * @returns 当前索引和动画状态
 */
export function useAnnouncementCarousel(totalCount: number, hasMultiple: boolean, isVisible: boolean) {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isAnimating, setIsAnimating] = useState(false)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (!hasMultiple || !isVisible) {
      return
    }

    intervalRef.current = setInterval(() => {
      setIsAnimating(true)
      timeoutRef.current = setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % totalCount)
        setIsAnimating(false)
      }, 300)
    }, 8000)

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [totalCount, hasMultiple, isVisible])

  return { currentIndex, isAnimating }
}
